module.exports = __webpack_public_path__ + "img/29.924494f3.jpg";